export default __webpack_public_path__ + "static/media/xwinbet365_receipt.aeca8dbc.jpg";